import React from 'react';
import { useIntl } from 'react-intl';
import { api, profilePhotouploadDir } from '../../../config';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import { Button } from 'react-bootstrap';
import cx from "classnames";

import StarRating from '../../StarRating/StarRating';
import messages from '../../../locale/messages';
import defaultIcon from '../../../../public/dashboard/defaultIconMenu.svg';
import withStyles from 'isomorphic-style-loader/withStyles';
import bt from '../../../components/commonStyle.css';
import s from './PreferredProviderDetails.css';

function PrefferedProviderDetails({ providerData }) {
    const {
        overallRating,
        completedBookingCount,
        profile,
        id
    } = providerData;

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();


    const selectedPartnerId = useSelector(state => state.form?.PreferredProviderForm?.values?.preferredPartnerId);

    const isSelected = selectedPartnerId === id;
    const isDisabled = selectedPartnerId && !isSelected;

    const handleAdd = () => {
        dispatch(change('PreferredProviderForm', 'preferredPartnerId', id));
    };

    const handleRemove = () => {
        dispatch(change('PreferredProviderForm', 'preferredPartnerId', null));
    };

    return (
        <div className={s.preferredProviderCard}>
            <div className={s.preferredProviderImageWrapper}>
                <img src={profile?.picture ? `${api.apiEndpoint}${profilePhotouploadDir}medium_${profile.picture}` : defaultIcon} alt="userProfile" />
            </div>
            <div className={s.preferredProviderCardInnerFlex}>
                <div>
                    <p className={s.providerName}>{profile?.firstName}</p>
                    <StarRating value={overallRating} className={s.providerRatingWrapper} />
                    <p className={s.providerServiceCount}>{formatMessage(messages.completedServices)} {completedBookingCount}</p>
                </div>
                <div className={s.providerButtonWrapper}>
                    {isSelected ? (
                        <a  href={'#'} onClick={handleRemove} tabIndex={0} className={cx(bt.commonLinkWithOutBorder,s.removeLinkButton)}> {formatMessage(messages.remove)} </a>
                    ) : (
                        <Button onClick={handleAdd} disabled={isDisabled} className={cx(bt.btnPrimary,bt.primarySmall,bt.fontWeight700,isDisabled ? bt.buttonDisableGray:'')}> {formatMessage(messages.select)} </Button>
                    )}
                </div>
            </div>

        </div>
    );
}

export default withStyles(bt, s)(PrefferedProviderDetails);
